<script>
import { mapState } from 'vuex';
import DatePicker from '../../components/datePicker.vue';
import Loading from '../../components/loading.vue';
import Picker from '../../components/picker.vue';
import FilterMenu from '../../components/filterMenu.vue';

export default {
    name: "news",
    data() {
        return {
            date: '',
            artist: [],
            artistActiveIndex: null,
            category: [],
            categoryActiveIndex: [],
            list: [],
            page: 1,
            allPage: 1,
            isLoading: false,
            sort: [
                { value: 1, name: this.$t('sort[0]') },
                { value: 2, name: this.$t('sort[1]') },
                { value: 3, name: this.$t('sort[2]') },
            ],
            sortValue: 0,
            isShowFilter: false,
            isShowSort: false,
        };
    },
    computed: {
        ...mapState(['galleryHome'])
    },
    components: {
        DatePicker,
        Picker,
        Loading,
        FilterMenu,
    },
    mounted() {
        this.getCategory();
        this.getList();
    },
    destroyed() {},
    watch: {
        date: 'pathChange',
        sortValue: 'pathChange',
        '$route': 'pathChange',
    },
    methods: {
        // 路由变更
        pathChange() { 
            this.list = [];
            this.page = 1;
            this.allPage = 1;
            this.getList();
            this.isShowFilter = false;
            this.isShowSort = false;
        },
        // 分类
        getCategory() { 
            this.$store.dispatch('getGalleryCategory', {
                type: 5
            }).then((result) => {
                if (result.code == 100) { 
                    // 筛选
                    this.artist = [
                        { name: '艺术家', children: result.data.artist },
                    ]
                    this.category = result.data.category.map(v => {
                        return {
                            ...v,
                            children: [...v.item]
                        }
                    })

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                
            });
        },
        getCheckedIndex() {
            // 路由是否有艺术家id
            if (this.artist.length > 0) { 
                if (this.$route.query.artist) { 
                    // 找到对应的索引
                    let index = this.artist[0].children.findIndex(v => v.id == this.$route.query.artist);
                    if (index != -1) { 
                        // 找到了
                        this.artistActiveIndex = [index];
                    } else {
                        // 没找到
                        this.artistActiveIndex = [null];
                    }
                } else {
                    // 路由没有艺术家id
                    this.artistActiveIndex = [null];
                }
            }
            
            // 路由是否有筛选id
            if (this.category.length > 0) { 
                if (this.$route.query.id) { 
                    const ids = this.$route.query.id.split(',');
                    this.categoryActiveIndex = this.category.map((v, i) => {
                        const checked = v.children.findIndex(item => {
                            return ids.findIndex(v => v == item.id) != -1
                        })
                        return checked != -1 ? checked : null;
                    });
                } else {
                    // 路由没有筛选id
                    this.categoryActiveIndex = this.category.map(() => null);
                }
            }
        },
        getList() { 
            if (this.isLoading) { 
                return;
            }
            let { query } = this.$route;
            this.isLoading = true;
            this.$store.dispatch('getGalleryList', {
                type: '',
                time: this.date,
                artist_id: query.artist ? query.artist : '',
                category_ids: query.id ? query.id : '',
                limit: 9,
                page: this.page,
                sort: this.sort[this.sortValue].value,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.list = this.list.concat(result.data.list);
                    this.allPage = result.data.last_page;

                    this.getCheckedIndex();
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
        getMore() { 
            if (this.isLoading) { 
                return false;
            }
            this.page++;
            this.getList();
        },
        changeValue() { 
            let query = {};
            // 时间
            // if (this.date) { 
            //     query.date = this.date;
            // }
            // 艺术家
            if (this.artistActiveIndex[0] != null) { 
                query.artist = `${this.artist[0].children[this.artistActiveIndex[0]].id}`;
            }
            // 分类
            let arr = [];
            // 根据索引获取id数组
            this.categoryActiveIndex.forEach((v, i) => {
                if (v != null) { 
                    arr.push(this.category[i].children[v].id);
                }
            })
            const ids = arr.join(',');
            if (ids != '') { 
                query.id = ids;
            }
            // 跳转
            this.$router.push({
                path: '/gallery/latestNews',
                query
            })
        },
    },
};
</script>

<template>
    <div class="news layout_body">
        <!-- banner -->
        <div class="banner">
            <div class="layout_bg" :style="`background-image: url(${galleryHome.news_banner});`"></div>
        </div>
        <div class="layout_main">
            <div class="layout_content">
                <p class="breadcrumb only_pc"><router-link to="/gallery">A<sup>+</sup> Studio Gallery</router-link> / 最新消息</p>
                <!--  -->
                <div class="only_mobile">
                    <div class="filter_tabs flex">
                        <div class="item" :class="{active: isShowFilter}" @click="isShowFilter = !isShowFilter">
                            <div class="name">筛选</div>
                        </div>
                        <div class="item" :class="{active: isShowSort}" @click="isShowSort = !isShowSort">
                            <div class="name">{{ sort[sortValue].name }}</div>
                        </div>
                    </div>
                    <div class="filter" v-if="isShowFilter">
                        <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeValue"/>
                        <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeValue"/>
                    </div>
                    <div class="sort" v-if="isShowSort">
                        <div class="item" v-for="(item, index) in sort" :key="index" @click="sortValue = index">{{ item.name }}</div>
                    </div>
                </div>
                <!--  -->
                <div class="tags flex justify_end align_center only_pc">
                    <DatePicker v-model="date"/>
                    <Picker :data="sort" v-model="sortValue"/>
                </div>
                <!--  -->
                <div class="wrapper flex">
                    <div class="filter only_pc" v-if="artist.length > 0 || category.length > 0">
                        <FilterMenu :data="artist" v-model="artistActiveIndex" @change="changeValue"/>
                        <FilterMenu :data="category" v-model="categoryActiveIndex" @change="changeValue"/>
                    </div>
                    <div class="content">
                        <div class="list flex flex_wrap">
                            <router-link class="item flex flex_column" v-for="(item, index) in list" :key="index" :to="`/gallery/latestNews/detail?id=${item.id}`">
                                <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                                <div class="text flex flex_column">
                                    <p class="type">{{ item.tag }}</p>
                                    <p class="name">{{ item.name }}</p>
                                    <div class="time flex align_start">
                                        <img :src="require('@/assets/images/icon_calendar.png')" alt="" class="icon calendar"/>
                                        <p>{{ item.time_text }}</p>
                                    </div>
                                    <!-- <div class="flex justify_end only_pc">
                                        <div class="btn layout_flex_center">更多信息</div>
                                    </div> -->
                                </div>
                            </router-link>
                        </div>
                        <Loading v-if="isLoading"/>
                        <p class="no_more" v-else-if="list.length == 0">暂无更多内容</p>
                        <p class="no_more" v-else-if="page == allPage">已经到底了</p>
                        <div class="flex justify_center" v-else>
                            <div class="btn_show_all layout_flex_center" @click="getMore">展示更多</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.filter_tabs{
    border-top: 1px solid #999;
    border-bottom: 1px solid #999;
    height: .7rem;
    margin: 0 -.3rem;
    .item{
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #999;
        &.active{
            &::after{
                transform: translate(0, 25%) rotate(-135deg);
            }
        }
        &:last-child{
            border-right: none;
        }
        .name{
            text-align: center;
        }
        &::after{
            content: "";
            display: block;
            width: .14rem;
            height: .14rem;
            border-right: 1px solid #999;
            border-bottom: 1px solid #999;
            transform: translate(0, -25%) rotate(45deg);
            margin-left: .2rem;
        }
    }
}
.filter,
.sort{
    @media only screen and (max-width: 750px) {
        margin: 0 -.3rem;
    }
}
.sort{
    padding: .3rem .6rem;
    border-bottom: 1px solid #999;
    .item{
        line-height: .6rem;
        font-size: .32rem;
    }
}
.tags{
    gap: .3rem;
    margin-bottom: .3rem;
}
.wrapper{
    gap: .5rem;
}
.content{
    flex: 1;
    @media only screen and (max-width: 750px) {
        padding: .3rem 0;
    }
}
.list{
    // gap: .56rem;
    gap: .39rem;
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        gap: .3rem;
    }
    .item{
        // width: 3.36rem;
        width: 2.54rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
        .cover{
            height: 0;
            padding-bottom: 80.36%;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                padding-bottom: 65.21%;
            }
        }
        .text{
            flex: 1;
            @media only screen and (max-width: 750px) {
                align-items: center;
            }
        }
        .type{
            font-size: .2rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .26rem;
            }
        }
        .name{
            font-size: .24rem;
            margin-bottom: .1rem;
            @media only screen and (max-width: 750px) {
                font-size: .32rem;
            }
        }
        .time{
            font-size: .18rem;
            // margin-bottom: .2rem;
            flex: 1;
            @media only screen and (max-width: 750px) {
                font-size: .22rem;
                margin-bottom: 0;
            }
            .icon{
                margin-top: .02rem;
            }
        }
        .icon{
            margin-right: .1rem;
            &.calendar{
                width: .21rem;
            }
            @media only screen and (max-width: 750px) {
                &.calendar{
                    width: .29rem;
                }
            }
        }
        .btn{
            font-size: .18rem;
            color: #666;
            border: 1px solid #666;
            border-radius: .1rem;
            height: .35rem;
            padding: 0 .15rem;
            cursor: pointer;
        }
    }
}
.btn_show_all{
    font-size: .2rem;
    border: 1px solid #666;
    color: #666;
    height: .48rem;
    padding: 0 .1rem;
    margin-top: .4rem;
    cursor: pointer;
}
</style>